import React, { createContext, useContext, useMemo, useState } from 'react';

const FiltersDrawerFabContext = createContext(null);

/** Comparte si el panel lateral de filtros (Mercado/Subastas) está abierto — para reposicionar el FAB de feedback. */
export function FiltersDrawerFabProvider({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const value = useMemo(() => ({ drawerOpen, setDrawerOpen }), [drawerOpen]);
  return <FiltersDrawerFabContext.Provider value={value}>{children}</FiltersDrawerFabContext.Provider>;
}

export function useFiltersDrawerFab() {
  const ctx = useContext(FiltersDrawerFabContext);
  if (!ctx) {
    return { drawerOpen: false, setDrawerOpen: () => {} };
  }
  return ctx;
}
